"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DynamicFieldWithFiles = exports.DynamicFormWithFiles = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _DynamicForm = require("../../DynamicForm"),
    _DynamicForm2 = _interopRequireDefault(_DynamicForm),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _compact = require("lodash/compact"),
    _compact2 = _interopRequireDefault(_compact);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
} // <DynamicFieldsWithFiles name="xyz" value={file} setValue={setFile} firebaseStorage={getFirebaseApp().storage()} namespace="form-abcd" props={{config:{maxBytes: 100000}}} />


var config = {
  maxBytes: 1048576,
  maxBytesError: "File Size exceeds allowed limit",
  maxBytesInfoMessage: "maximum size: "
},
    stuffProps = function stuffProps(a, b, c) {
  return (0, _extends3.default)({
    config: config
  }, (0, _get2.default)(c, "props", {}), {
    firebaseStorage: a,
    namespace: (0, _compact2.default)([b, (0, _get2.default)(c, ["props", "subnamespace"], "")]).join("/")
  });
},
    addFirebaseStorage = function addFirebaseStorage(a, b, c) {
  return c.map(function (c) {
    return "firebasefile" === (0, _get2.default)(c, "type") ? (0, _extends3.default)({}, c, {
      props: stuffProps(a, b, c)
    }) : ["subform:single", "subform:multiple"].includes((0, _get2.default)(c, "type")) ? addFirebaseStorage(a, b, c.subFormFields) : c;
  });
},
    DynamicFormWithFiles = exports.DynamicFormWithFiles = _react2.default.memo(function (a) {
  return _react2.default.createElement(_DynamicForm2.default, (0, _extends3.default)({}, a, {
    formFields: addFirebaseStorage(a.firebaseStorage, a.namespace, a.formFields)
  }));
}),
    DynamicFieldWithFiles = exports.DynamicFieldWithFiles = _react2.default.memo(function (a) {
  return _react2.default.createElement(_DynamicForm.DynamicField, (0, _extends3.default)({}, a, {
    type: "firebasefile",
    props: stuffProps(a.firebaseStorage, a.namespace, a)
  }));
});